import styled from "@emotion/styled"

const BreadcrumbsEl = (props) => <ol {...props} />

const Breadcrumbs = styled(BreadcrumbsEl)`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-left: -10px;
  margin-right: -10px;
  margin-bottom: 30px;
  margin-top: 0;
  padding-left: 0;
  list-style: none;
`

export default Breadcrumbs
